import { useState, useEffect, useCallback } from 'react';
import { translations } from '../i18n/translations';

export const useI18n = () => {
    const [language, setLanguage] = useState(() => {
        // Get language from localStorage or default to 'ru'
        const savedLang = localStorage.getItem('language');
        return savedLang || 'ru';
    });

    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];

        for (const k of keys) {
            if (value && typeof value === 'object') {
                value = value[k];
            } else {
                break;
            }
        }

        // Fallback to English if translation not found
        if (value === undefined) {
            let fallbackValue = translations['en'];
            for (const k of keys) {
                if (fallbackValue && typeof fallbackValue === 'object') {
                    fallbackValue = fallbackValue[k];
                } else {
                    break;
                }
            }
            return fallbackValue || key;
        }

        return value || key;
    };

    const changeLanguage = useCallback((lang) => {
        if (lang !== language) {
            setLanguage(lang);
            localStorage.setItem('language', lang);
        }
    }, [language]);

    useEffect(() => {
        document.documentElement.lang = language;
    }, [language]);

    return {
        language,
        changeLanguage,
        t,
        isRussian: language === 'ru',
        isEnglish: language === 'en'
    };
};